
import { Component, Vue } from 'vue-property-decorator';
import { JwtStore } from '@/store/modules';

import QvSelect from '@/components/FormComponents/QvSelect.vue';
import DetailTag from '@/components/DetailTag.vue';

@Component({
  components: {
    QvSelect,
    DetailTag
  },
  meta: {
    title: 'User Detail'
  }
})
export default class Profile extends Vue {
  get userDetail() {
    return JwtStore.UserDetail;
  }
}
